import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState, useRecoilCallback } from 'recoil'
import { MODAL_SIZE_SM, ModalConfirm } from 'mailup-web-components'
import { modalConfirmExitState } from 'Pages/MessageEdit/recoil/state/modals'
import { exitCallback } from 'Pages/MessageEdit/recoil/callbacks/callbacks'
import modalMessageRedirect from 'Helpers/modalMessageRedirect'

const ModalConfirmExit = () => {
  const intl = useIntl()
  const { show } = useRecoilValue(modalConfirmExitState)
  const { redirect } = modalMessageRedirect()

  const exit = useRecoilCallback(exitCallback, [])
  const handleCancel = useResetRecoilState(modalConfirmExitState)
  const handleConfirm = () =>
    exit(
      false,
      messageType => {
        redirect(messageType)
      },
      true
    )

  return (
    <ModalConfirm
      show={show}
      showClose
      closeOnOverlayClick
      data-mu-test='modal-confirm-exit'
      size={MODAL_SIZE_SM}
      onClose={handleCancel}
      title={intl.formatMessage({ id: 'Load.Bee.ConfirmExitTitle' })}
      message={intl.formatMessage({ id: 'Load.Bee.ConfirmExitDescription' })}
      onClickConfirm={handleConfirm}
      onClickCancel={handleCancel}
      stringConfirm={intl.formatMessage({ id: 'Load.Common.Exit' })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
    />
  )
}

export default ModalConfirmExit
